export default __webpack_public_path__ + "static/media/TuHogarOnline-circle.40ce3d93.png";